







import { Vue, Component } from 'vue-property-decorator';
import { IState } from '../../store';
import DataMatrixReader from './DataMatrixReader.vue';

@Component({
    components: {
        DataMatrixReader,
    },
})
export default class OdpReader extends Vue {

    private get canShowContent() {
        return this.state.currentSettings.isAcceptedTerms;
    }

    private get state() {
        return this.$store.state as IState;
    }

    public goToOdpInformation() {
        this.$router.push({
                path: '/OdpInformation',
            });
    }
}
